import * as Yup from 'yup';
import { optionalText, requiredText, requiredUrl } from './CommonValidation';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const AISolutionsScheme = Yup.object().shape({
  // solutionName: Yup.string().trim().required('Solution name is required'),
  // solutionOwner: Yup.string().trim().required('Solution owner is required'),
  // organizationUnit: Yup.string()
  //   .trim()
  //   .required('Organisation unit is required'),
  // organizationSubUnit: Yup.string()
  //   .trim()
  //   .required('Organisation sub unit is required'),
  // stakeholder: Yup.string().trim().required('Stakeholder is required'),
  // legalentity: Yup.string().trim().required('Legal entity is required'),
  // usercustomer: Yup.string().trim().required('User / customer is required'),
  // businessprocess: Yup.string()
  //   .trim()
  //   .required('Business processes is required'),
  // uses: Yup.string()
  //   .trim()
  //   .required('Uses is required')
  //   .min(10, 'Please enter atleast 10 characters'),
  // purpose: Yup.string()
  //   .trim()
  //   .required('Purpose is required')
  //   .min(10, 'Please enter atleast 10 characters'),
  // businessValue: Yup.string()
  //   .trim()
  //   .required('Business value is required')
  //   .min(10, 'Please enter atleast 10 characters'),
  // businessGoals: Yup.string()
  //   .trim()
  //   .required('Business goals is required')
  //   .min(10, 'Please enter atleast 10 characters'),
  // platform: Yup.string().trim().required('Platform is required'),
  // risktier: Yup.string().trim().required('Risk tier is required'),

  solutionName: requiredText('Solution name', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  solutionOwner: requiredText('Solution owner', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  organizationUnit: requiredText('Organisation unit', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  organizationSubUnit: requiredText('Organisation sub unit', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  stakeholder: requiredText('Stakeholder', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  legalentity: requiredText('Legal entity', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  usercustomer: requiredText('User / customer', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  businessprocess: requiredText('Business processes', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  uses: requiredText('Uses', {
    minLength: 10,
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  purpose: requiredText('Purpose', {
    minLength: 10,
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  businessValue: requiredText('Business value', {
    minLength: 10,
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  businessGoals: requiredText('Business goals', {
    minLength: 10,
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),

  platform: optionalText('Platform', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  technicaldocument: requiredUrl('Technical documentation link'),
  vendorname: optionalText('Vendor name', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  consumtionmethod: optionalText('Consumption method', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  environment: optionalText('Environment', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  versioncontrol: optionalText('Version control method', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
});

export { AISolutionsScheme };
